import { api, CHAT_DOCUMENTS_TAG } from '@/api';

export interface ChatDocumentDeleteRequest {
  chatDocumentId: string;
}

export interface ChatDocumentDeleteResponse {
  success: boolean;
}

const chatDocumentDeleteApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postChatDocumentDelete: builder.mutation<ChatDocumentDeleteResponse, ChatDocumentDeleteRequest>({
      query: (body) => ({
        url: '/chat/document/delete',
        method: 'POST',
        body,
      }),
      // Invalidate every cached `/chat/documents` list, otherwise the deleted document comes back into the input.
      invalidatesTags: [{ type: CHAT_DOCUMENTS_TAG, id: 'LIST' }],
    }),
  }),
});

export const { usePostChatDocumentDeleteMutation } = chatDocumentDeleteApi;
